export default "__VITE_ASSET__33197e75__"